import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import AuthLayout from './components/AuthLayout'
import FindOrganizationForm from './find-organization/FindOrganizationForm'
import { useSignedInHome } from './find-organization/use-signed-in-home'

/**
 * Entrée de connexion de la plateforme (#346), cible du CTA « Se connecter » de
 * la landing. Chaque organisation a son propre écran de connexion, sous son
 * adresse (`/o/<slug>/login`) : le visiteur la nomme, puis y est emmené.
 *
 * Navigation dure : l'écran de l'org vit sous un autre basename, hors de portée
 * de react-router — et c'est ce basename qui porte l'habillage de l'org.
 *
 * `?org=` porte le slug d'une URL d'org inconnue (`KnownOrgGate`) : l'écran
 * s'ouvre dessus, avec l'erreur.
 */
function FindOrganization() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const leaving = useSignedInHome()
  if (leaving) return null

  return (
    <AuthLayout tagline={t('login.tagline')} taglineSub={t('login.tagline.sub')}>
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center gap-6">
        <div className="flex flex-col gap-2">
          <h1 className="font-heading text-4xl font-extrabold tracking-tight">{t('findOrganization.title')}</h1>
          <p className="text-muted-foreground">{t('findOrganization.subtitle')}</p>
        </div>
        <FindOrganizationForm
          unknown={searchParams.get('org') ?? undefined}
          onFound={slug => window.location.assign(`/o/${slug}/login`)}
        />
      </div>
    </AuthLayout>
  )
}

export default FindOrganization
